import React from "react";
import Layout from "../../components/layout";

const AssignPermission = () => {
  return <>AssignPermission</>;
};

export default AssignPermission;
